import React from 'react';

interface StepperCProgressProps {
  percent: number;
  className?: string;
}

const StepperCProgress: React.FC<StepperCProgressProps> = ({
  percent,
  className,
}) => (
  <div
    className={['cprogress', className].filter(Boolean).join(' ')}
    style={{ '--p': percent / 100 } as React.CSSProperties}
  >
    <div className='cprogress-ring' aria-hidden='true'></div>
    <span className='cprogress-val'>{percent}%</span>
  </div>
);

export default StepperCProgress;
